/** Account-scoped judging data only. Credentials never enter this cache. */
export function judgeCache(principal: string, competition: string) {
  const prefix = JSON.stringify(["scorio.judge-data.v1", principal, competition]);
  const read = <T>(key: string): T | null => {
    try {
      const raw = localStorage.getItem(`${prefix}:${key}`);
      return raw ? (JSON.parse(raw) as T) : null;
    } catch {
      return null;
    }
  };
  return {
    read,
    write(key: string, value: unknown) {
      try {
        localStorage.setItem(`${prefix}:${key}`, JSON.stringify(value));
      } catch {
        /* Cache readiness stays false when storage is full or unavailable. */
      }
    },
    async get<T>(key: string, load: () => Promise<T>): Promise<T> {
      if (!navigator.onLine) {
        const cached = read<T>(key);
        if (cached !== null) return cached;
        throw new Error("This heat is not ready offline. Connect to load it first.");
      }
      let data: T;
      try {
        data = await load();
      } catch (error) {
        if (error && typeof error === "object" && "status" in error && error.status === 0) {
          const cached = read<T>(key);
          if (cached !== null) return cached;
        }
        throw error;
      }
      try {
        this.write(key, data);
      } catch {
        /* Scoring queue reports its own durable-write failures. */
      }
      return data;
    },
  };
}
